<template>
    <div class="relative min-h-screen min-w-screen flex flex-col justify-between pb-8">
      <div :class="!errorState ? 'pb-20' : 'pb-32'">
          <default-header 
              type="dark"
              headerClasses="pb-0"
              :masked="false"
          />
        <img src="@/assets/images/6-digit-code.png" alt="" class="w-full max-w-xs mx-auto -mt-4 pb-4 px-8">
        <div class="px-8 text-primary max-w-xs text-center mx-auto py-4">
          <h1 class="text-lg font-sans-secondary">{{ $t('enter4digitcode') }}</h1>
          <p>{{ $t('pleseenter4digit') }}</p>
        </div>
        <div class="otpInput flex flex-col items-center justify-center w-full py-0" @click="scrollToTop()">
            <v-otp-input
              ref="otpInput"
              input-classes="otp-input"
              :class="errorState ? 'error' : 'default'"
              separator=""
              :num-inputs="6"
              :should-auto-focus="true"
              :is-input-num="true"
              :conditionalClass="['one', 'two', 'three', 'four']"
              :placeholder="['0', '0', '0', '0', '0', '0']"
              @on-change="handleOnChange"
              @on-complete="handleOnComplete"
            />
            <p class="text-red-500 mt-5 text-sm" v-if="errorState">{{ $t('incorrectcode') }}</p>
        </div>

      </div>
      <div class="flex flex-col space-y-5 px-6 fixed left-0 bottom-6 w-full" v-if="!errorState">
          <default-button 
            @click="getAppToken"
            buttonClasses=""
            :text="$t('continue')"
          />
      </div>
      <div class="flex flex-col space-y-5 px-6 fixed left-0 bottom-6 w-full" v-else>
          <default-button 
            @click="clearInput()"
            buttonClasses=""
            :text="$t('tryagain')"
          />
      </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import DefaultHeader from "@/components/Header.vue";
import DefaultButton from "@/components/Button.vue";

export default {
  components: {
    DefaultHeader,
    DefaultButton,
  },
  data() {
    return {
      errorState: false,
      ac: null,
      otpCode: null
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.token
    })
  },
  mounted() {
    this.ac = this.$route.query.ac;
    this.oid = this.$route.query.oid;
 
    if (window.localStorage.getItem('token')) {
      if(window.localStorage.getItem('oldOID') != this.oid ) {
        // hit here if the old oid matches oid and do nothing
      } else {
        this.axios
        .get(`${process.env.VUE_APP_API_BASE_URL}/api/app/device`)
        .then(() => {
          this.$router.push({ name: 'Dashboard' });
        })
      }
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    handleOnChange(value){
      this.errorState = false;
      this.otpCode = parseInt(value);
    },
    getAppToken() {
      const formData = {
        deviceCode: String(this.otpCode),
      }

      this.axios
        .post(`${process.env.VUE_APP_API_BASE_URL}/api/app/booking/verify?ac=${this.ac}&oid=${this.oid}`, formData)
        .then((res) => {
          this.storeAppToken(res.token);
        }).catch(() => {
          this.errorState = true;
        })
    },
    storeAppToken(token) {
      this.$store
      .dispatch('storeAppAuthToken', token)
      .then(() => {

        if(window.localStorage.getItem('oldOID') != this.$route.query.oid) {
          window.localStorage.setItem('oldOID', this.$route.query.oid); 
        }

        this.$router.push({ name: 'Dashboard' });

      }).catch(() => {
        alert('something went wrong')
      })
    },
    clearInput() {
      this.errorState = false;
    }
  }
};
</script>

<style lang="scss">
.error {
  .otp-input {
    @apply text-red-500 border border-red-500
  }
}
.default {
  .otp-input {
      color: #223672;
      border: 1px solid rgba(27, 42, 59, 0.1);
  }
}
.otp-input {
  width: 39px;
  height: 39px;
  padding: 5px;
  margin: 0 3px;
  font-size: 20px;
  border-radius: 4px;
  text-align: center;
}
.otp-input:focus-visible {
  @apply border border-primary;
}
/* Background colour of an input field with value */
.otp-input.is-complete {
  /* background-color: #e4e4e4; */
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.otpInput {
  input::placeholder {
    font-size: 15px;
    text-align: center;
    font-weight: 600;
  }
}
</style>